/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* Licensed under the MIT License. See LICENSE.md in the project root for license terms.
*--------------------------------------------------------------------------------------------*/

const supportedTextFilesTypes = /\.(ts|tsx|js|jsx|json|svg|txt|text|css|scss|sass|md|markdown|csv|htm|html|xhtml|xml|log|sql|php|py|sh|bat|bak|cfg|rtf)$/i;
const noExtension = /^[^.]*$/i;
const supportedImageFilesTypes = /\.(jpg|jpeg|png|apng|avif|gif|webp|bmp)$/i;

export const isImageType = (filePath: string) => {
  return supportedImageFilesTypes.test(filePath);
}

export const isSupportedTextType = (filePath: string) => {
  return supportedTextFilesTypes.test(filePath) || noExtension.test(filePath);
}

export const isBinaryType = (filePath: string) => {
  return !(isImageType(filePath) || isSupportedTextType(filePath))
}